import type { PlayerBody } from '../types';
import { KB_RESIST_CAP, KB_SCALING_K } from './constants';
import { clamp, normalize } from './vec2';

/**
 * GDD knockback: KB = F_base × (1 + k × (HP_max − HP) / HP_max) × (1 − R),
 * with HP clamped to [0, HP_max] and R clamped to [0, KB_RESIST_CAP].
 */
export function computeKnockback(
  baseForce: number,
  hp: number,
  hpMax: number,
  resist: number,
  k: number = KB_SCALING_K,
): number {
  if (hpMax <= 0 || baseForce <= 0) return 0;
  const missing = (hpMax - clamp(hp, 0, hpMax)) / hpMax;
  const r = clamp(resist, 0, KB_RESIST_CAP);
  return baseForce * (1 + k * missing) * (1 - r);
}

/** Add a knockback impulse of `magnitude` (units/s) along (dirX, dirY) to the body's slide velocity. */
export function applyImpulse(
  body: PlayerBody,
  dirX: number,
  dirY: number,
  magnitude: number,
): void {
  const dir = normalize(dirX, dirY);
  body.vx += dir.x * magnitude;
  body.vy += dir.y * magnitude;
}
